<template>
  <nav class="navbar navbar-default nav_index navbar-fixed-top">
    <div class="container-fluid container nav-c">
      <!-- Brand and toggle get grouped for better mobile display -->
      <div class="navbar-header">
        <button type="button" class="navbar-toggle collapsed btn_cus" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false">
          <span class="sr-only">Toggle navigation</span>
          <!--<span class="icon-bar"></span>-->
          <!--<span class="icon-bar"></span>-->
          <!--<span class="icon-bar"></span>-->
          <img src="../assets/btn_bg.png" alt="">
        </button>
        <img src="../assets/logo.png" class="logo" alt="">
      </div>

      <!-- Collect the nav links, forms, and other content for toggling -->
      <div class="collapse navbar-collapse" id="navbar-collapse">
        <ul class="nav navbar-nav navbar-right">
          <li ><router-link :data-toggle="collapse" data-target="#navbar-collapse" class="firstHome" exact to="/">首页</router-link ></li>
          <li class="dropdown open-xs">
            <a class="dropdown-toggle" :class="{ active: jianjie }" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">公司介绍 </a>
            <ul class="dropdown-menu add-img" style="transform: translateX(31%);">
              <li><router-link to="/introduction" :data-toggle="collapse" data-target="#navbar-collapse">公司简介</router-link></li>
              <li><router-link to="/hope" :data-toggle="collapse" data-target="#navbar-collapse">愿景和价值观</router-link></li>
              <li><router-link to="/honor" :data-toggle="collapse" data-target="#navbar-collapse">荣誉资质</router-link></li>
              <img src="../assets/nav_pic01@3x.jpg" class="nav_img" alt="">
            </ul>
          </li>
          <li class="dropdown  open-xs">

           <!--  <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">服务内容 <span class="caret"></span></a>
            <ul class="dropdown-menu" style="transform: translateX(25%);">
              <li><router-link to="/idc" :data-toggle="collapse" data-target="#navbar-collapse">IDC和大带宽</router-link></li> -->

            <a class="dropdown-toggle" :class="{ active: neirong }" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">服务内容 </a>
            <ul class="dropdown-menu add-img add-img2"  style="transform: translateX(25%);">
              <li><router-link to="/idc" :data-toggle="collapse" data-target="#navbar-collapse">IDC和大带宽服务</router-link></li>
              <li><router-link to="/cdn" :data-toggle="collapse" data-target="#navbar-collapse">融合CDN</router-link></li>

              <li><router-link to="/internet" :data-toggle="collapse" data-target="#navbar-collapse">物联网应用平台</router-link></li>
              <li><router-link to="/software" :data-toggle="collapse" data-target="#navbar-collapse">创新类营销管理软件</router-link></li>
              <li><router-link to="/ict" :data-toggle="collapse" data-target="#navbar-collapse">ICT系统集成类服务</router-link></li>
              <li><router-link to="/cardNetwork" :data-toggle="collapse" data-target="#navbar-collapse">全网物联网卡销售及服务</router-link></li>
              <li><router-link to="/integralMall" :data-toggle="collapse" data-target="#navbar-collapse">积分商城</router-link></li>
              <img src="../assets/nav_pic02.png" class="nav_img" alt="">
            </ul>
          </li>
          <li class="dropdown  open-xs">
            <a  class="dropdown-toggle" :class="{ active: fangan }" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">解决方案及案例 </a>
            <ul class="dropdown-menu add-img add-img2" style="transform: translateX(17%);">
              <li><router-link to="/customer" :data-toggle="collapse" data-target="#navbar-collapse">大客户</router-link></li>
              <li><router-link to="/cloud" :data-toggle="collapse" data-target="#navbar-collapse">混合云和私有云服务</router-link></li>
              <li><router-link to="/tms" :data-toggle="collapse" data-target="#navbar-collapse">运输管理平台(TMS)</router-link></li>
              <li><router-link to="/medical" :data-toggle="collapse" data-target="#navbar-collapse">物联网医疗诊断平台</router-link></li>
              <li><router-link to="/serviceCloud" :data-toggle="collapse" data-target="#navbar-collapse">云备份、云服务、云安全</router-link></li>
              <img src="../assets/nav_pic03.png" class="nav_img" alt="">
            </ul>
          </li>
          <li><router-link to="/recruit" :data-toggle="collapse" data-target="#navbar-collapse" class="firstHome">招聘信息</router-link></li>
          <li><router-link to="/contact" :data-toggle="collapse" data-target="#navbar-collapse" class="firstHome">联系我们</router-link></li>
        </ul>
      </div><!-- /.navbar-collapse -->
    </div><!-- /.container-fluid -->
  </nav>
</template>

<script>
  import $ from 'jquery'
  export default {
    name: 'Nav',

    data() {
      return {
        collapse: window.innerWidth <= 768 ? "collapse" : "",
        jianjie: false,
        neirong: false,
        fangan: false,
      }
    },
    watch: {
      '$route' (to) {
        // 对路由变化作出响应...
        if (to.fullPath == "/") {
          this.$data.jianjie = false
          this.$data.neirong = false
          this.$data.fangan = false
          return
        }
        this.$data.jianjie = "/introduction /hope /honor".indexOf(to.fullPath) !== -1 ? true : false
        this.$data.neirong = "/idc /internet /software /ict /cardNetwork /integralMall".indexOf(to.fullPath) !== -1 ? true : false
        this.$data.fangan = "/customer /cloud /tms /medical /serviceCloud".indexOf(to.fullPath) !== -1 ? true : false
      }
    },
    mounted() {
      $('ul.nav li.dropdown').hover(function() {
        // if ($(window).width()<=768) {
        //   return
        // }
        $(this).find('.dropdown-menu').stop(true, true).delay(200).slideDown(500);
      }, function() {
        // if ($(window).width()<=768) {
        //   return
        // }
        $(this).find('.dropdown-menu').stop(true, true).delay(200).slideUp(500);
      });
    },
    created: function () {

      var self = this
      this.path = this.$route.fullPath
      if (this.$route.fullPath == "/") {
        this.$data.jianjie = false
        this.$data.neirong = false
        this.$data.fangan = false
        return
      }
      this.$data.jianjie = "/introduction /hope /honor".indexOf(this.$route.fullPath) !== -1 ? true : false
      this.$data.neirong = "/idc /internet /software /ict /cardNetwork".indexOf(this.$route.fullPath) !== -1 ? true : false
      this.$data.fangan = "/customer /cloud /tms /medical /serviceCloud".indexOf(this.$route.fullPath) !== -1 ? true : false
      window.onresize = function() {
        var res;
        if (res){clearTimeout(res)}
        res = setTimeout(function(){
          if (window.innerWidth <= 768) {
            self.collapse = "collapse"
          } else  {
            self.collapse = ""
          }
        },20);
      };
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logo{
    height: 50px;
    margin-top: 26px;
  }
  .navbar {
    min-height: 100px;
  }
  .navbar-header {
    height: 100px;
  }
  .btn_cus {
    padding: 0px;
    border: none;
  }
  .btn_cus:focus,.btn_cus:hover {
    background: transparent!important;
  }
  .nav_index {
    padding: 0px 0px;
    background: #fff;
    border: none;
  }
  .navbar {
    margin-bottom: 0px;
  }
  .add-img .nav_img {
    display: none;
  }
  @media (min-width: 769px) {
    .nav>li>a {
      padding-left: 13px;
      padding-right: 13px;
    }
    .add-img {
      width: 380px;
      padding: 40px 200px 40px 16px;

          }
    .add-img .nav_img {
      display: block;
      position: absolute;
      width: 166px;
      right: 16px;
      top: 24px;
      padding-left: 21px;
      border-left: 1px solid #ccc;
    }
    .add-img2 {
      width: 400px;
    }
    .add-img2 .nav_img {
      padding-top: 25px;
      padding-bottom: 25px;
    }
    .nav-c {
      min-width: 800px;
    }
  }
  @media (max-width: 768px) {
    .navbar-default .navbar-nav>li>a {
      text-align: center;
    }
    .navbar-nav .open-xs .dropdown-menu {
      position: static;
      float: none;
      width: auto;
      margin-top: 0;
      background-color: transparent;
      border: 0;
      -webkit-box-shadow: none;
      box-shadow: none;
    }
    li.dropdown>ul {
      transform: translateX(0%)!important;
    }
    li.dropdown>ul li a {
      text-align: center;
    }
  }

  .dropdown-toggle{

    font-size:16px;
  }
  .firstHome{
    font-size:16px;
  }

  </style>
